import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { mockChatRepo } from './data/mockChatRepo';
import './styles/globals.css';

// THE data-source swap point. Replace `mockChatRepo` with the api-client +
// SSE implementation here — every component reads the repo from router context,
// so no component changes when the backend is wired in.
const chatRepo = mockChatRepo;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient, chatRepo },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

// Make the router instance type-safe across the app (typed params, links, ...).
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
